import { Pipe, PipeTransform } from '@angular/core';
import { VocTerm, VocTerms } from '../models/voc-term';

@Pipe({
  name: 'vocTermById'
})
export class VocTermByIdPipe implements PipeTransform {

    /* Get vocabulary term by identifier */
    transform(voc: VocTerms, termId: number, norm: boolean = false, returnAsObj: boolean = false): string | VocTerm {
        const termFound = voc.find(
            function (vocTerm: VocTerm) {
                return vocTerm.pkid === termId;
            });

        if (termFound) {
            if (returnAsObj) {
                return termFound;
            } else {
                if (norm) {
                    return termFound.term_norm;
                } else {
                    return termFound.term;
                }
            }
        } else {
            if (returnAsObj) {
                return null;
            } else {
                return '';
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/voc-term-by-id.pipe.ts